import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminPharmaciesNewRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/pharmacies/new',
}).lazy(() =>
  import('pages/admin/Pharmacies/AdminPharmacyNewPage/AdminPharmacyNewPage').then((d) => d.Route)
);
